module.exports = __webpack_public_path__ + "img/i-distance.8f9af47b.svg";